class SkeletonTooltipController{draw(){}drawAt(){}hide(){}hideAll(){}enableToolTip(){}disableToolTip(){}setStyle(){}}export default{extension:SkeletonTooltipController,name:'ToolTipController',type:'plugin'};


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-core/src/dummy-tooltip-controller/index.js
// module id = null
// module chunks = 